import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import ScrollToTop from './components/ScrollToTop';
import { ContactModalProvider } from './components/common/ContactModalContext';
import Home from './pages/Home';
import About from './pages/About';
import B2B from './pages/tracks/B2B';
import B2C from './pages/tracks/B2C';
import Colleges from './pages/tracks/Colleges';
import Courses from './pages/Courses';
import Offerings from './pages/Offerings';
import CategoryPage from './pages/CategoryPage';
import CourseDetail from './pages/CourseDetail';
import Resources from './pages/Resources';
import Blog from './pages/Blog';
import BlogDetail from './pages/BlogDetail';
import Campaigns from './pages/Campaigns';
import Contact from './pages/Contact';
import ContactSubmissions from './pages/ContactSubmissions';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import KonfHubEnroll from './pages/KonfHubEnroll';
import './App.css';

function App() {
  // Suppress noisy cross-origin "Script error." (primarily from KonfHub widget)
  useEffect(() => {
    const originalOnError = window.onerror;

    window.onerror = function (message, source, lineno, colno, error) {
      if (message === 'Script error.') {
        // swallow generic Script error so React overlay doesn't keep popping up
        return true;
      }
      if (typeof originalOnError === 'function') {
        return originalOnError(message, source, lineno, colno, error);
      }
      return false;
    };

    const handler = (event) => {
      if (event.message === 'Script error.') {
        event.preventDefault();
      }
    };

    window.addEventListener('error', handler);

    return () => {
      window.onerror = originalOnError;
      window.removeEventListener('error', handler);
    };
  }, []);

  return (
    <BrowserRouter>
      <ContactModalProvider>
        <ScrollToTop />
        <div className="App">
          <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/tracks/corporates" element={<B2B />} />
          <Route path="/tracks/b2b" element={<Navigate to="/tracks/corporates" replace />} />
          <Route path="/tracks/individuals" element={<B2C />} />
          <Route path="/tracks/b2c" element={<Navigate to="/tracks/individuals" replace />} />
          <Route path="/tracks/colleges" element={<Colleges />} />
          <Route path="/tracks/universities" element={<Navigate to="/tracks/colleges" replace />} />
          <Route path="/courses" element={<Courses />} />
          <Route path="/offerings" element={<Offerings />} />
          <Route path="/offerings/:categoryId" element={<CategoryPage />} />
          {/* Keep backward compatibility for older links */}
          <Route path="/course/salesforce-developer" element={<Navigate to="/course/salesforce-ai-developer" replace />} />
          <Route path="/course/:courseSlug" element={<CourseDetail />} />
          <Route path="/resources" element={<Resources />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:postId" element={<BlogDetail />} />
          <Route path="/campaigns" element={<Campaigns />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/contact/submissions" element={<ContactSubmissions />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-of-service" element={<TermsOfService />} />
          <Route path="/enroll" element={<KonfHubEnroll />} />
          </Routes>
        </div>
      </ContactModalProvider>
    </BrowserRouter>
  );
}

export default App;
